import {
  MY_BOOKED_SPEAKERS,
  FETCH_SPEAKERS,
  OPEN_SPEAKER_DETAILS,
  SHOW_BACK_SCREEN
} from '../actions';

export function bookedSpeakers(state = {}, action) {
  switch (action.type) {
    case MY_BOOKED_SPEAKERS:
      return action.payload;
    default:
      return state;
  }
}

export function speakersReducer(state = {}, action) {
  switch (action.type) {
    case FETCH_SPEAKERS:
      return action.payload;
    default:
      return state;
  }
}

export function speakerDetailsReducer(state = {}, action) {
  switch (action.type) {
    case OPEN_SPEAKER_DETAILS:
      return action.payload;
    default:
      return state;
  }
}

export function showBackScreenSpeaker(state = false, action) {
  switch (action.type) {
    case SHOW_BACK_SCREEN:
      return action.payload;
    default:
      return state;
  }
}
